import { EditorialCapabilityImage } from './ScenarioCapabilityReading';

/** Additional supplied plates have no existing issue/capability relation. Keep them separate. */
const illustrations = [
  {
    file: 'F10-portable-pump-support',
    title: '便携泵与保障',
    note: '图示泵与水带的物理供水形态。水源、扬程、供电与人员操作条件需另行核查，不是线索监测设备。',
  },
  {
    file: 'F11-aerial-water-drop',
    title: '航空灭火支持',
    note: '图示航空洒水形态，不能与无人机巡查混同。空域、机组、载荷和任务权限需另行核实，不生成投水指令。',
  },
  {
    file: 'F12-postfire-ecology-assessment',
    title: '灾后评估记录',
    note: '图示灾后地面记录，不代表已完成生态或损失鉴定；评估时间、范围与专业方法须单独确认。',
  },
] as const;
export function ForestExtendedTechnicalIllustrations() {
  return (
    <details data-extended-forest-illustrations>
      <summary>延伸技术图示（3项，未关联当前典型问题）</summary>
      <p>执行包的补充技术情境示意，未新增所需能力或正式关系。</p>
      <div className="scc-extended-illustrations">
        {illustrations.map((row) => (
          <article key={row.file}>
            <h3>{row.title}</h3>
            <EditorialCapabilityImage path={`04_MEDIA/forest/${row.file}.webp`} title={row.title} />
            <p>{row.note}</p>
          </article>
        ))}
      </div>
    </details>
  );
}
